import React from 'react';
import './loading.css';
import { AiOutlineLoading3Quarters } from "react-icons/ai"; 

const Loading= () => {
 

  return (
    // <div  className="loding-body" > 
    // </div>
    <div className='container_size'>
          <div className="loading-shimmer"></div>
          <div className="loading-shimmer"></div> 
    </div>
   
  );
};

export default Loading;
